export default __webpack_public_path__ + "static/media/home-consulting-01.4cd40c54.jpg";